import { useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

export namespace CheckEmail {
  export type Response = { isRegistered: boolean }
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = (email?: string) => ['is-email-known', { email }]

const queryFetcher = (email?: string) => () => {
  if (!email) return { isRegistered: false }
  return ApiClient.post<CheckEmail.Response>('/v1/clients/check', { data: { email } })
}

export const useCheckEmail = (email?: string, options?: CheckEmail.Options) => {
  return useQuery<CheckEmail.Response, CheckEmail.Error>(
    createKey(email),
    queryFetcher(email),
    options
  )
}
